import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import config from '@/config';
import api from '@/shared/api';
import HandleHttpError from '@/shared/services/HandleHttpError';
import { useIntl } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import messages from '../messages';
import { IntraCompanyQueryKey } from './queryKey';
const useBatchToggleIntraCompanyBilling = () => {
    const { setShowModalInfo } = useModalContext();
    const queryClient = useQueryClient();
    const intl = useIntl();
    const { mutateAsync } = useMutation(values => api.base.post(`${config.appUrls.api}/api/IntraCompany/NeverIntraCompany`, values), {
        onSuccess: () => {
            queryClient.invalidateQueries([IntraCompanyQueryKey.Overview]);
            ToastrService.success();
        },
        onError: e => {
            HandleHttpError(intl)(e);
        },
    });
    const toggleIntraCompanyBilling = async (reg) => {
        if (!reg.neverInvoice) {
            // Make active again
            await mutateAsync(reg);
        }
        else {
            return new Promise(resolve => {
                setShowModalInfo({
                    modalType: ModalType.YesNo,
                    title: intl.formatMessage(messages.NeverInvoiceRegistration),
                    message: intl.formatMessage(messages.DoNotIntraCompanyBillRegistrationConfirm),
                    onSave: async () => {
                        await mutateAsync(reg);
                        resolve();
                    },
                    onClose: async () => {
                        resolve();
                    },
                });
            });
        }
    };
    return { toggleIntraCompanyBilling };
};
export default useBatchToggleIntraCompanyBilling;
